import {Component, Input, OnInit} from "@angular/core";

@Component({
  selector: 'yo-desktop-button',
  templateUrl: './desktop-button.component.html',
  styleUrls: ['./desktop-button.component.scss'],
  standalone: false
})
export class DesktopButtonComponent implements OnInit {

  @Input() type: string = "button";
  @Input() label: string = "";
  @Input() tooltip: string = "";
  @Input() iconClass: string = "";

  public _buttonClass = "main";
  public _iconClass = "";

  ngOnInit(): void {
    this.initIconClass();
  }

  initIconClass = () => {
    if (!this.label && !this.iconClass)
      this._iconClass = "fas fa-question";
    else
      this._iconClass = this.iconClass;

    return this._iconClass;
  }
}
